
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavaidAttributes } from '../../../typings/features/navaid-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';

@Component({
  selector: 'jmkw-navaid-detail',
  standalone: true,
  imports: [],
  templateUrl: './navaid-detail.component.html',
  styleUrls: ['./navaid-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavaidDetailComponent extends AbstractDetailComponent<NavaidAttributes> {
  @Input() attributes!: NavaidAttributes;
}
